module.exports = new __parcel__URL__("JSM-board-illustration.b7063fec.png").toString();